import { createAsyncThunk } from "@reduxjs/toolkit";
import { uploadsServer } from "~/constants";
import { UPLOAD_ADDITIONAL_FILES } from "~/slices/constants";
import type { RootState } from "~/store";

interface DeleteFolderPayload {

  folderPath: string;
}
interface DeleteFilePayload {

  prefix: string;
}

export const deletFileThunk = createAsyncThunk(
  "files/deleteFile",
  async (payload: DeleteFilePayload, {getState, rejectWithValue }) => {
    const { prefix } = payload;
    const state = getState() as RootState;
    const org = state.organization.organization;
    if (!org) {
      return rejectWithValue("Organization not found");
    }
    const bucketName = `3dbia_organization_${org.id}`;
    const url = `${uploadsServer}delete/file`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bucketName,
          fileName: prefix,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to delete file");
      }

      const deletedFile = await response.json();
      console.log("deletedFile", deletedFile);
      
      return deletedFile;
    } catch (err) {
      console.error("deleteFile error:", err);
      return rejectWithValue(err instanceof Error ? err.message : "Unknown error");
    }
  }
);

export const deleteFolderThunk = createAsyncThunk(
  "files/deleteFolder",
  async (payload: DeleteFolderPayload, {getState, rejectWithValue }) => {
    const { folderPath } = payload;
    const state = getState() as RootState;
    const survey = state.displayedSurvey;
    const task = state.tasks.selectedTask
    const subTask = state.tasks.selectedSubTask
    console.log("deleteFolderThunk task", {
      subTask,
      folderPath
    });
    const bid = task.bid;
    const surveyId = task.survey_id;
    const bucketName = `3dbia_organization_${task.organization_id}`
    const url = `${uploadsServer}delete`;
    let prefix = `bid_${bid}/survey_${surveyId}/Images/${folderPath}`;
    if (subTask && subTask.name === UPLOAD_ADDITIONAL_FILES) {
      prefix = `bid_${bid}/survey_${surveyId}/${folderPath}`;
    }
    console.log(prefix)
    // const prefix = `bid_${bid}/survey_${surveyId}/Images/${folderPath}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bid,
          bucketName,
          surveyId,
          folderPath: prefix,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to delete files");
      }

      const deletedFiles = await response.json();
      console.log("deletedFiles", deletedFiles);
      
      return folderPath;
    } catch (err) {
      console.error("deleteFiles error:", err);
      return rejectWithValue(err instanceof Error ? err.message : "Unknown error");
    }
  }
);